// extracted by mini-css-extract-plugin
export default {"desktop":"1105px","menuWidth":"213px","main":"App_main__d+RRc","menu":"App_menu__2HjKJ","gridContents":"App_gridContents__GDkOw","gridCenter":"App_gridCenter__FiW25"};